import { EventEmitter, Injectable, OnChanges, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { APIService } from './api.service';
import { FunctionService } from './function.service';
import { Player, Tornament, UserTrace, Setting, Match, Draw } from './Main.Model';
import { CookieService } from 'ngx-cookie-service'

@Injectable({
  providedIn: 'root'
})
export class DataService {

  Settings?: Setting[];
  Players!: Player[];
  Matches!: Match[];
  Torns!: Tornament[];
  MainStatus: string = 'Home';
  EntryOpenFilter: Boolean = false;
  LoggedInUser!: Player;
  SelectedTable: String = "";
  LoggedInUserAlreadyEnteredInTorn?: boolean;
  SelectedTorn!: Tornament;
  SelectedDraw!: Draw;
  SelectedPlayer!: Player;
  TornStatus: string = "ChangeTorn";
  // public SettingsRetreived = new Subject<Setting[]>();
  public MatchesLoaded = new Subject<boolean>();
  public PlayersLoaded = new Subject<boolean>();
  AllowTornUpdate?: boolean;
  EmailToRecover!: string;
  VideoFiles?: String[];
  Directors?: Player[];
  newTorn!: Tornament;
  newDraw!: Draw;
  TableRows1?: number;
  TableRows2?: number;
  DrawChangedEmitter = new EventEmitter<boolean>();
  NeedToWinString: string = '';
  Loser?: Player;
  MatchScore?: String;
  SelectedMatch?: Match;
  //showKO4PlayerOption: Boolean;
  NormalLimit!: number;
  SelectedColumnIndex?: number;
  SelectedRowIndex?: number;
  SelectedLabelIndex?: number;
  DBStatus?: string;
  CurrentUser: Player = new Player();
  LoginCookie?: string;
  filenames = signal<string[]>([]);// writable signal to store filenames
  isAddingNewDraw: boolean = false;
  selectedDrawIndex: number = 0;
  isEditingMatchScore: boolean = false;
  
  constructor(private APIService: APIService, private cookieService: CookieService) { 
    this.LoggedInUser = new Player();
    this.LoggedInUser.accessLevel = 0;
    this.LoggedInUser.name = 'Login';
    //this.UserTrace = new UserTrace();
  }

  async getInitialData() {
    this.Settings = await this.APIService.getSettings();
    if (this.Settings.length == 0) {
      this.DBStatus = "Server is down!"
      console.error("Database is down!!!!");
    }
  }

  async LogUserInFromCookie() {
    this.Players = await this.APIService.getPlayers();
    this.LoginCookie = this.cookieService.get('Login-Cookie');
    if (+this.LoginCookie > 0 && this.Players) {
      //auto log user in as they logged in within last 7 days
      this.LoggedInUser = this.Players.find((p: Player) => {return p.id === +this.LoginCookie!})!;
    }
  }

  updateFiles(newFiles: string[]) {
    this.filenames.set(newFiles);
  }

  changeMainStatus(newStatus: string) {
    this.MainStatus = newStatus;
    sessionStorage.setItem('MainStatus', this.MainStatus);
  }

  changeTornStatus(newStatus: string) {
    this.TornStatus = newStatus;
    sessionStorage.setItem('TornStatus', this.TornStatus);
  }

  async refreshPlayers() {
    this.Players = await this.APIService.getPlayers();
    this.Players.forEach(player => {//need to convert all DOBs to date objects.....
      if (player.DOB) {
        player.DOB = new Date(player.DOB.toString());
      }
    });
    this.PlayersLoaded.next(true);
    if (!this.Directors) {
      this.Directors = this.Players.filter((p) => p.accessLevel! > 1);
    }
    this.Players.sort(function (a, b) { return a.name?.localeCompare(b.name!) ?? 0; });
  }

  async refreshMatches() {
    this.Matches = await this.APIService.getAllMatches();//this should get all matches
    //need to create objects for each match's DateOfMatch
    this.Matches.forEach(match => {
      match.dateOfMatch = new Date(match.dateOfMatch!.toString());
    });
    this.MatchesLoaded.next(true);
  }

  convertTornDates(torn: Tornament) {
    torn.dateOfEvent = new Date(torn.dateOfEvent!);
      torn.closingDate = new Date(torn.closingDate!);
      torn.endDateOfEvent = new Date(torn.endDateOfEvent!);
      return torn;
  }

  async refreshTorns() {
    var torns = await this.APIService.getTorns();
    torns.forEach(torn => {
      torn = this.convertTornDates(torn);
    });
    
    torns.sort((a, b) => {
      if (a.dateOfEvent! > b.dateOfEvent!) {
        return -1
      }
      if (a.dateOfEvent! < b.dateOfEvent!) {
        return 1
      }
      return 0;
    });
    this.Torns = torns;
  }
  
  // async getVideoFolders() {
  //   this.VideoFiles = await this.APIService.GetVideoFolders();
  // }

  SaveState() {
    sessionStorage.setItem('MainStatus', this.MainStatus);
    sessionStorage.setItem('TornStatus', this.TornStatus);
    //sessionStorage.setItem('SelectedTorn', JSON.stringify(this.SelectedTorn));
    //sessionStorage.setItem('SelectedDraw', JSON.stringify(this.SelectedDraw));
    //sessionStorage.setItem('SelectedMatch', JSON.stringify(this.SelectedMatch));
    sessionStorage.setItem('EntryOpenFilter', this.EntryOpenFilter.toString());
    sessionStorage.setItem('SelectedTable', this.SelectedTable.toString());
  }

  LoadState() {
    //this.SelectedTorn = JSON.parse(sessionStorage.getItem('SelectedTorn'));
    //this.SelectedDraw = JSON.parse(sessionStorage.getItem('SelectedDraw'));
    //this.SelectedMatch = JSON.parse(sessionStorage.getItem('SelectedMatch'));
    if (sessionStorage.hasOwnProperty('EntryOpenFilter')) {
      this.EntryOpenFilter = JSON.parse(sessionStorage.getItem('EntryOpenFilter')!);
    }
    if (sessionStorage.hasOwnProperty('SelectedTable')) {
      this.SelectedTable = sessionStorage.getItem('SelectedTable')!;
    }
  }

  ChangeDraw(draw: Draw) {
    this.SelectedDraw = draw;
    this.isAddingNewDraw = false;
    this.DrawChangedEmitter.emit(true);
  }
}
